import { mediaQuery } from 'modules/utils';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { theme } from '../theme';
import { PopoutTheme } from './PopoutTheme';

interface StyledPopoutProps {
  theme?: string;
  activeTheme?: any;
}

export const StyledPopoutBackdrop = styled.div<StyledPopoutProps>`
  width: 100vw;
  height: 100vh;

  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 9998;
  background-color: ${theme.colors.backdrop};
`;

export const StyledPopoutContainer = styled.div<StyledPopoutProps>`
  ${(props) => {
    if (props.theme === PopoutTheme.Dark) {
      return `
        background-color: ${props.activeTheme.colors.primaryW};
      `;
    }
    if (props.theme === PopoutTheme.Teal) {
      return `background-color: ${props.activeTheme.colors.primaryT5}`;
    }

    return `
      background-color: ${props.theme.colors.primaryW};
    `;
  }};
  
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;

  min-width: 100vw;
  max-width: 100vw;

  padding: 0.963rem;
  overflow-y: auto;

  ${mediaQuery('md')} {
    width: 55rem;
    min-width: 49rem;
    padding: 6rem;
  }

  z-index: 9999;
  display: inline-flex;
  flex-direction: column;
`;

export const StyledCloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledBackdropTransitions = styled(CSSTransition)`
  &.popout-backdrop-enter {
    opacity: 0;
  }

  &.popout-backdrop-enter-active {
    opacity: 1;
    transition: opacity 400ms ease-in;
  }

  &.popout-backdrop-exit {
    opacity: 1;
  }

  &.popout-backdrop-exit-active {
    opacity: 0;
    transition: opacity 400ms ease-out;
  }
`;

export const StyledPopoutContainerTransitions = styled(CSSTransition)`
  &.popout-container-enter {
    transform: translateX(100%);
  }

  &.popout-container-enter-active {
    transform: translateX(0);
    transition: transform 400ms ease-in;
  }

  &.popout-container-exit {
    transform: translateX(0);
  }

  &.popout-container-exit-active {
    transform: translateX(100%);
    transition: transform 400ms ease-in;
  }
`;

export const StyledComponentSwitchTransitions = styled(CSSTransition)`
  &.component-switch-enter-active,
  &.component-switch-exit-active {
    transition: opacity 300ms;
  }
`;
